import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
const terms = [{
  title: '1. Scope of services',
  content: 'We will provide brand identity services as outlined in the agreed proposal or statement of work. This may include but is not limited to brand strategy visual identity logo design typography colour palette and brand guidelines. Any work not expressly included is considered out of scope and may require a separate agreement or additional fees.'
}, {
  title: '2. Project timeline and client responsibilities',
  content: 'Project timelines are dependent on timely feedback content and approvals from you. Delays in providing required materials or feedback may impact delivery dates and we are not responsible for delays caused by the client.'
}, {
  title: '3. Fees and payment',
  content: 'All fees are as set out in the agreed proposal. Unless otherwise stated a deposit is required before work begins with the balance payable upon project completion. Invoices must be paid within the stated payment period. Late payments may result in work being paused until payment is received.'
}, {
  title: '4. Revisions',
  content: 'The project includes a reasonable number of revision rounds as outlined in the proposal. Additional revisions or changes outside the agreed scope may be charged at our standard rates.'
}, {
  title: '5. Intellectual property',
  content: 'Upon full payment you will receive ownership of the final approved brand identity deliverables. We retain ownership of all concepts unused drafts and working files unless otherwise agreed in writing. We reserve the right to showcase the work in our portfolio website and marketing materials unless confidentiality has been agreed in advance.'
}, {
  title: '6. Third party materials',
  content: 'Any third party assets such as fonts stock imagery or software licences are subject to their own terms. Unless explicitly stated responsibility for ongoing licences rests with you.'
}, {
  title: '7. Confidentiality',
  content: 'Both parties agree to keep confidential any non public information shared during the project unless disclosure is required by law or agreed in writing.'
}, {
  title: '8. Limitation of liability',
  content: 'We will carry out services with reasonable skill and care. Our liability is limited to the total fees paid for the project. We are not liable for indirect losses loss of profit or business interruption.'
}, {
  title: '9. Termination',
  content: 'Either party may terminate the project with written notice. Fees for work completed up to the termination date remain payable. Deposits are non refundable once work has commenced.'
}, {
  title: '10. Governing law',
  content: 'These Terms and Conditions are governed by and interpreted in accordance with the laws of England and Wales and the courts of England and Wales shall have exclusive jurisdiction.'
}];
export function TermsAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="terms" className="py-20 md:py-28 px-4 md:px-6 border-b border-white/[0.06]" data-id="element-279">
      <div className="max-w-7xl mx-auto" data-id="element-280">
        <ScrollReveal data-id="element-281">
          <div className="mb-12 md:mb-16" data-id="element-282">
            <span className="text-accent font-bold tracking-[0.2em] text-xs md:text-sm uppercase block mb-4" data-id="element-283">
              Legal
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-white uppercase tracking-tight mb-6 md:mb-8" data-id="element-284">
              Terms &<br data-id="element-285" />
              conditions
            </h2>
            <p className="text-zinc-400 leading-relaxed font-light text-base md:text-lg max-w-3xl" data-id="element-286">
              These Terms and Conditions apply to all Brand Identity services
              provided by AVY Consultancy Limited referred to as we us or our.
              By engaging our services the client referred to as you or your
              agrees to these terms.
            </p>
          </div>
        </ScrollReveal>

        <div className="space-y-px bg-white/[0.06] border border-white/[0.06]" data-id="element-287">
          {terms.map((term, index) => <ScrollReveal key={index} delay={index * 0.04} data-id="element-288">
              <div className="bg-surface overflow-hidden" data-id="element-289">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 md:p-6 bg-surface hover:bg-white/[0.02] transition-colors text-left" data-id="element-290">
                  <span className="font-bold text-white text-sm md:text-base uppercase tracking-wide" data-id="element-291">
                    {term.title}
                  </span>
                  <ChevronDownIcon className={`w-4 h-4 md:w-5 md:h-5 text-zinc-500 transition-transform duration-300 flex-shrink-0 ml-4 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-292" />
                </button>
                <AnimatePresence data-id="element-293">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-294">
                      <div className="px-5 md:px-6 pb-6 md:pb-8 text-zinc-400 text-sm md:text-base leading-relaxed font-light border-t border-white/[0.06] pt-4 bg-[#0A0A0F]" data-id="element-295">
                        {term.content}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </ScrollReveal>)}
        </div>
      </div>
    </section>;
}